import { FIREBASE_URL, requestMethods } from '../constants';

const DOLLAR_ENDPOINT = '/analitics/dollar-rate';

const dollarService = {
  /**
   * Obtiene el tipo de cambio USD/MXN desde Banxico a través del backend
   * @returns {Promise<{banxicoRate: number, date: string, success: boolean}>}
   */
  getDollarRate: async () => {
    try {
      const response = await fetch(`${FIREBASE_URL}${DOLLAR_ENDPOINT}`, {
        method: requestMethods.GET,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        let errorMessage = `Error HTTP: ${response.status}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (e) {
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error('La respuesta del servidor indica que no fue exitosa');
      }

      if (typeof data.rate !== 'number') {
        throw new Error('El formato de la tasa de cambio no es válido');
      }

      let formattedDate = data.date;
      let isoDate = null;

      if (data.date) {
        if (data.date.includes('/')) {
          const [day, month, year] = data.date.split('/');
          isoDate = `${year}-${month}-${day}`;
        } else {
          isoDate = data.date;
        }
      }

      return {
        banxicoRate: data.rate,
        date: data.date,
        isoDate: isoDate,
        success: data.success,
        lastUpdated: isoDate ? new Date(isoDate).toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }) : new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })
      };
    } catch (error) {
      console.error('Error en dollarService.getDollarRate:', error);
      throw error;
    }
  },

  getOurDollarRate: async (discount = 1.00) => {
    try {
      const response = await dollarService.getDollarRate();

      return {
        ...response,
        ourRate: response.banxicoRate - discount,
        discount: discount
      };
    } catch (error) {
      throw error;
    }
  }
};

export default dollarService;